var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogoRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3395FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_logo_round_svg__clip0_29420_5081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.033 22.5c6.037 0 9.34-5.002 9.34-9.339 0-.14-.004-.284-.01-.425a6.667 6.667 0 001.637-1.7 6.47 6.47 0 01-1.884.517 3.3 3.3 0 001.443-1.816 6.6 6.6 0 01-2.083.797 3.286 3.286 0 00-5.596 2.993A9.324 9.324 0 019.115 10.1a3.286 3.286 0 001.016 4.38 3.285 3.285 0 01-1.487-.41v.041a3.281 3.281 0 002.633 3.219c-.482.132-.989.151-1.48.056a3.29 3.29 0 003.065 2.282A6.584 6.584 0 018 21.026a9.311 9.311 0 005.033 1.474z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_logo_round_svg__clip0_29420_5081"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgTwitterLogoRound;